import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { MovieDocumentResponse } from "../../../../common/api/catalogue-api/movie/MovieDocumentResponse";
import { useAssetListingConfig } from "../../common/config/useAssetListingConfig";
import { useMovieAssetsApi } from "../api/useMovieAssetsApi";
import { SingleMovie } from "./SingleMovie";
import { SingleMovieContext } from "./SingleMovieContext";

type SingleMovieProviderProps = React.PropsWithChildren<unknown>;

export const SingleMovieProvider: React.FC<SingleMovieProviderProps> = (props: SingleMovieProviderProps) => {
    const { movieId } = useParams<{ movieId: string }>();

    const { children } = props;

    const { getMovieById } = useMovieAssetsApi();

    const [movie, setMovie] = useState<SingleMovie>(emptyMovie);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { listingConfig, saveListingConfig } = useAssetListingConfig();

    useEffect(() => {
        setIsLoading(true);
        getMovieById(movieId)
            .then((response: MovieDocumentResponse) => {
                setMovie(response);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [movieId]);

    return (
        <SingleMovieContext.Provider value={{ movieId, movie, isLoading, listingConfig, saveListingConfig }}>
            {children}
        </SingleMovieContext.Provider>
    );
};

const emptyMovie: SingleMovie = {
    id: "",
    title: "",
    subtype: 0,
    versions: []
};
